import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { fetchAppointmentTimeSlotPlans } from "../../../../lib/api/resources/appointmentTimeSlotPlans";
import { appointmentTimeSlotPlanColumns } from "./lib/constants/appointmentTimeSlotPlanColumns";
import { Link } from "react-router-dom";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";

export const AppointmentTimeSlotPlansList = () => {
  const appointmentTimeSlotPlansQuery = useQuery({
    queryKey: ["appointmentTimeSlotPlans"],
    queryFn: fetchAppointmentTimeSlotPlans,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/appointment-time-slots/plans/create">
          <Button icon={<PlusOutlined />}>Nieuwe planning</Button>
        </Link>
      </Space>
      <Table
        columns={appointmentTimeSlotPlanColumns}
        dataSource={appointmentTimeSlotPlansQuery.data}
        loading={appointmentTimeSlotPlansQuery.isLoading}
        pagination={false}
      />
    </div>
  );
};
